<template>
  <div class="container store-promo-coupons">
    <div class="row">
      <div
        v-for="(item, index) in coupons"
        class="coupon-container"
        :class="columnClass"
        :key="index"
      >
        <img
          :src="item.remote_image"
          class="img-fluid store-coupon-image"
          @click="selectCoupon(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coupons: Array,
  },
  computed: {
    couponCount() {
      return this.coupons.length;
    },
    columnClass() {
      if (this.coupons.length == 2) {
        return "col-md-6 col-xs-12";
      }
      if (this.coupons.length == 3) {
        return "col-md-4 col-xs-12";
      }
      if (this.coupons.length == 4) {
        return "col-md-3 col-xs-12";
      }
      return false;
    },
  },
  created() {},
  methods: {
    selectCoupon(index) {
      this.$emit("couponClicked", index);
    },
  },
};
</script>
<style>
.appt-store .store-row.selected {
  padding: 15px;
}
.coupon-container {
  text-align: center;
}
.store-coupon-image {
  max-height: 400px;
}
</style>
